<template>
	<div>
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/childList' }">
					<i class="el-icon-s-custom"></i> 宝宝管理
				</el-breadcrumb-item>
				<el-breadcrumb-item>更新宝宝信息</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px">
				<el-row>
					<el-row>
					<el-col :span="24">
						<el-form-item :label="'头像'" prop="habPHOT" >
							<el-upload class="avatar-uploader" action="" :show-file-list="false" :auto-upload="false" :on-change="uploadImg">
								<el-image v-if="ruleForm.habPHOT" fit="fill" disabled :src="ruleForm.habPHOT" :onerror="defaultImg" class="avatar"></el-image>
								<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							</el-upload>
						</el-form-item>
					</el-col>
					</el-row>
					<el-col :span="12">
						<el-form-item :label="'宝宝ID'" prop="habMSID">
							<el-input v-model="ruleForm.habMSID" :placeholder="'请输入宝宝ID'" :disabled="true"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
					</el-col>
				</el-row>
				
				<el-row>
					<el-col :span="12">
						<el-form-item :label="'姓名'" prop="habNAME">
							<el-input v-model="ruleForm.habNAME" :placeholder="'请输入宝宝姓名'" maxlength="20"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="22">
						<el-form-item :label="'性别'" prop="habGSEX">
							<el-radio-group v-model="ruleForm.habGSEX">
								<el-radio label="1">男</el-radio>
								<el-radio label="0">女</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item :label="'生日'" prop="habBIRT">
							<!-- <el-date-picker v-model="ruleForm.habBIRT" type="date" :placeholder="'请选择日期'" value-format="yyyy-MM-dd" align="center"></el-date-picker> -->
						<el-date-picker type="date" placeholder="选择日期" v-model="ruleForm.habBIRT" style="width: 100%;"></el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item :label="'就读幼儿园'" prop="valueSABSAAI" class="font">
							<el-select v-model="ruleForm.valueSABSAAI" clearable disabled
							:placeholder="'请选择就读幼儿园'" class="handle-select mr10" 
							@change="SABSAAIchange">
							   <el-option
								 v-for="item in ruleForm.optionsSABSAAI"
								 :key="item.SAAMSID"
								 :label="item.SAANAME"
								 :value="item.SAAMSID">
							   </el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item :label="'就读年级'" prop="valueSABSADI" class="font">
							<el-select v-model="ruleForm.valueSABSADI" clearable
							:placeholder="'请选择所在年级'" class="handle-select mr10" 
							@change="SABSADIchange" :disabled="SABSADIdisabled">
								<el-option
								 v-for="item in ruleForm.optionsSABSADI"
								:key="item.SADMSID"
								:label="item.SADNAME"
								:value="item.SADMSID">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item :label="'就读班级'" prop="hadSABI" class="font">
							<el-select v-model="ruleForm.hadSABI" clearable
							:placeholder="'请选择所在班级'" 
							class="handle-select mr10" :disabled="HADSABIdisabled">
								<el-option
								 v-for="item in ruleForm.optionsHADSABI"
								:key="item.SABMSID"
								:label="item.SABNAME"
								:value="item.SABMSID">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<!-- <el-row>
					<el-col :span="22">
						<el-form-item :label="'删除状态'" prop="habDELF">
								<el-select v-model="ruleForm.habDELF" clearable disabled
								:placeholder="'请选择删除状态'" 
								class="handle-select mr10">
									<el-option
										 v-for="item in ruleForm.optionsDELF"
										 :key="item.INIKEY2"
										 :label="item.INIDISP"
										 :value="item.INIKEY2">
									</el-option>
								</el-select>
							</el-form-item>
					</el-col>
				</el-row> -->
				<el-row>
					<el-col :span="24">
						<div class="submit">
							<el-form-item>
								<el-button @click="goBack()" class="goback">返回</el-button>
								<el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
							</el-form-item>
						</div>
					</el-col>
				</el-row>
			</el-form>
			<!-- vueCropper 剪裁图片实现-->
			   <el-dialog :title="'剪裁图片'" :visible.sync="imgCutVisible" append-to-body>
			     <div class="cropper-content">
			       <div class="cropper" style="text-align:center">
					<vueCropper
						ref="cropper"
						:img="imgCutOption.img"
						:outputSize="imgCutOption.size"
						:outputType="imgCutOption.outputType"
						:info="true"
						:full="imgCutOption.full"
						:canMove="imgCutOption.canMove"
						:canMoveBox="imgCutOption.canMoveBox"
						:original="imgCutOption.original"
						:autoCrop="imgCutOption.autoCrop"
						:fixed="imgCutOption.fixed"
						:fixedNumber="imgCutOption.fixedNumber"
						:centerBox="imgCutOption.centerBox"
						:infoTrue="imgCutOption.infoTrue"
						:fixedBox="imgCutOption.fixedBox"
					  ></vueCropper>
			       </div>
			     </div>
			     <div slot="footer" class="dialog-footer">
			       <el-button @click="imgCutVisible = false">返回</el-button>
			       <el-button type="primary" @click="finish">提交</el-button>
			     </div>
			   </el-dialog>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'editChild',
		inject: ['reload'],
		data() {
			//验证字符串
			const validateFontSize = (rule,value,callback)=>{	
					if (value.toString().length < 1 || value.toString().length > 20) {
						callback(new Error('请输入长度在1~20之间的字符'))  //长度在1-20之间
					} else {
						callback();
					}
			 }
			return {
				web_sphon: sessionStorage.getItem("ms_username"), //web 登录用户ID
				imgCutVisible: false,
				imgCutOption: {
					img: '', // 裁剪图片的地址
					info: true, // 裁剪框的大小信息
					outputSize: 0.9, // 裁剪生成图片的质量
					outputType: 'jpg', // 裁剪生成图片的格式
					canScale: true, // 图片是否允许滚轮缩放
					autoCrop: true, // 是否默认生成截图框
					fixedBox: false, // 固定截图框大小 不允许改变
					fixed: true, // 是否开启截图框宽高固定比例
					fixedNumber: [1, 1], // 截图框的宽高比例
					full: false, // 是否输出原图比例的截图
					canMoveBox: true, // 截图框能否拖动
					original: false, // 上传图片按照原始比例渲染
					centerBox: false, // 截图框是否被限制在图片里面
					infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
				},
				defaultImg: 'this.src="' + require("../../assets/img/users_128.png") + '";this.onerror=null',
				
				SABSADIdisabled:false,
				HADSABIdisabled:false,
				
				habChangeData: {},
				ruleForm: {
					habDELF:'',
					optionsDELF: [],
					habPHOT:'',
					habNAME: '',
					imgbase64: '',
					habBIRT: '',
					habGSEX: '',
					valueSABSAAI: '',
					optionsSABSAAI: [],
					valueSABSADI: '',
					optionsSABSADI: [],
					hadSABI: '',
					optionsHADSABI: []
				},
				rules: {
					habNAME: [{
						required: true,
						message: '请输入宝宝姓名', 
						trigger: ['blur', 'change'],
						validator: validateFontSize
					}],
					habGSEX:[
						{ 
						 required: true, 
						 message: '请选择性别', 
						 trigger:['blur','change']
						}
					],
					habDELF:[
						{ 
						 required: true, 
						 message: '请选择删除状态', 
						 trigger:['blur','change']
						}
					],
					habBIRT:[
						{ 
						 required: true, 
						 message: '请选择生日', 
						 trigger:['blur','change']
						}
					],
					valueSABSAAI: [{
						required: true,
						message: '请选择就读幼儿园',
						trigger: ['blur', 'change']
					}],
					valueSABSADI: [{
						required: true,
						message: '请选择就读年级',
						trigger: ['blur', 'change']
					}],
					hadSABI: [{
						required: true,
						message: '请选择就读班级',
						trigger: ['blur', 'change']
					}]
				}
			};
		},
		watch: {
			$route(to, from) {
				if (to.name === "editChild") {
					this.dummyCreated();
				}
			}
		},
		created() {
			this.habMSID = this.$route.query.HABMSID;
			// this.getDELF(); //获取删除状态
			this.getSAA(); 	//获取幼儿园信息
			
			this.getData(this.habMSID);
			
			// this.getSAD(this.ruleForm.valueSABSAAI); //获取年级信息
			// this.getSAB(this.ruleForm.valueSABSADI); //获取班级信息	
		},
		mounted() {
			this.$bus.$on('change', () => {
				//刷新当前页面
				this.reload()
			})		
		},
		methods: {
			dummyCreated () {
				this.habMSID = this.$route.query.HABMSID;
				this.getDELF(); //获取删除状态
				this.getSAA(); 	//获取幼儿园信息
				
				this.getData(this.habMSID);
				
				// this.getSAD(this.ruleForm.valueSABSAAI); //获取年级信息
				// this.getSAB(this.ruleForm.valueSABSADI); //获取班级信息	
			},
			//获取删除信息
			getDELF(){
				const self_shop = this;
				var postUrl = 'WCF/WEB/svcINI.svc/Get_INI_List';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_shop.web_sphon, //web侧 登录邮箱
						sINIKEY1: 10005 //删除 10005
					}
				)
				.then((response) =>{
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					if(resCount>0){
						this.ruleForm.optionsDELF= response.data.KKDT;
					}		
				})
				.catch((error) =>{
					this.ruleForm.habDELF='';
					this.$message({
					message: '获取删除状态请求失败',  //请求失败
					type: 'error'
					});
					
				});
			},
			//获取幼儿园信息
			getSAA(){
				const self_agent = this;
				var postUrl='WCF/WEB/svcSAA.svc/Get_SAA_GardenList';
				//网络请求接口
				this.$axios.post(
					//请求的url
						postUrl,
					//请求参数
					{ 
						sPHON: self_agent.web_sphon, //web侧 登录ID  tihs.web_suuid
					}
				)
				.then((response) =>{
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					if(resCount>0){
						this.ruleForm.optionsSABSAAI= response.data.KKDT;
					}
				    else{
						this.ruleForm.optionsSABSAAI='';
						this.ruleForm.valueSABSAAI='';
					}
				})
				.catch((error) =>{
					this.ruleForm.valueSABSAAI='';
					this.$message({
					  message: '获取幼儿园信息请求失败',  //请求失败
					  type: 'error'
					});
				});	
			},
			//获取年级信息
			getSAD(valueSAAI){
				const self_agent = this;
				var postUrl='WCF/WEB/svcSAD.svc/GET_SAD_GradeLIST';
				//网络请求接口
				this.$axios.post(
					//请求的url
						postUrl,
					//请求参数
					{ 
						sPHON: self_agent.web_sphon, //web侧 登录ID  tihs.web_suuid
						sSAAI: valueSAAI //web侧 登录ID  tihs.web_suuid
					}
				)
				.then((response) =>{
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					if(resCount>0){
						this.ruleForm.optionsSABSADI= response.data.KKDT;
					}
					else{
						this.ruleForm.optionsSABSADI='';
						this.ruleForm.valueSABSADI='';
					}
				})
				.catch((error) =>{
					this.ruleForm.valueSABSADI='';
					this.$message({
					  message: '获取年级信息请求失败',  //请求失败
					  type: 'error'
					});
				});	
			},
			//获取班级信息
			getSAB(valueSABSADI){
				const self_agent = this;
				var postUrl='WCF/WEB/svcSAB.svc/GET_SAB_GradeLIST';
				//网络请求接口
				this.$axios.post(
					//请求的url
						postUrl,
					//请求参数
					{ 
						sPHON: self_agent.web_sphon, //web侧 登录ID  tihs.web_suuid
						sSADI: valueSABSADI //年级ID
					}
				)
				.then((response) =>{
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					if(resCount>0){
						this.ruleForm.optionsHADSABI= response.data.KKDT;
					}
					else{
						this.ruleForm.optionsHADSABI='';
						this.ruleForm.hadSABI='';
					}
				})
				.catch((error) =>{
					//this.ruleForm.hadSABI='';
					this.$message({
					  message: '获取班级信息请求失败',  //请求失败
					  type: 'error'
					});
				});	
			},
			//上传头像
			uploadImg(file, fileList) {
				var that = this
				//判断图片类型
				if (file.raw.type == 'image/jpeg' || file.raw.type == 'image/png' || file.raw.type == 'image/JPG') {
					var isJPG = true
				} else {
					isJPG = false
				}
				// 判断图片大小
				const isLt2M = file.raw.size / 1024 / 1024 < 20
				if (!isJPG) {
					that.$message.error('上传产品图片只能是 JPG/PNG/JPEG 格式!') //上传产品图片只能是 JPG/PNG/JPEG 格式!
					return false;
				}
				if (!isLt2M) {
					that.$message.error('上传产品图片大小不能超过 20MB!') //上传产品图片大小不能超过 20MB!
					return false;
				}
			
				if (isJPG && isLt2M) {
					var reader = new FileReader();
					reader.readAsDataURL(file.raw);
					reader.onload = function(e) {
						// that.ruleForm.imageUrl = this.result;
						// that.ruleForm.imgbase64 = this.result.split(',')[1];
						that.imgCutOption.img = this.result;
						that.imgCutVisible = true;
					}
				}
			},
			// 剪切图片确定方法
			finish() {
			  this.$refs.cropper.getCropBlob((data) => {
				var reader = new FileReader();
				reader.readAsDataURL(data);
				var that = this;
				reader.onload = function(e) {
					that.ruleForm.habPHOT = this.result;
					that.ruleForm.imgbase64 = this.result;
					that.imgCutVisible = false;
				}
			  })
			  },
			//获取宝宝信息
			getData(habMSID) {
				const self = this;
				var postUrl = 'WCF/WEB/svcHAB.svc/GET_HAB_BYID';
				//debugger;
				//console.log(habMSID);
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self.web_sphon, 
							sMSID: habMSID //宝宝ID
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resStatus = response.status;
						if (resStatus == "200") { //网络请求成功
							let resCount = response.data.KKDTCOUNT;
							if (resCount > 0) {
								//返回列信息赋值到页面上 
								this.ruleForm.habMSID = response.data.KKDT[0].HABMSID; //宝宝ID
								this.ruleForm.habPHOT = response.data.KKDT[0].HABPHOT +"?timestamp=" + new Date().getTime(); //头像
								this.ruleForm.habNAME = response.data.KKDT[0].HABNAME; //姓名
								this.ruleForm.habGSEX = response.data.KKDT[0].HABGSEX; //性别
								this.ruleForm.habDELF = response.data.KKDT[0].HABDELF; //删除状态
								this.ruleForm.habBIRT = response.data.KKDT[0].HABBIRT; //生日
								this.ruleForm.valueSABSAAI = response.data.KKDT[0].HADSAAI; //就读幼儿园
							    this.ruleForm.valueSABSADI = response.data.KKDT[0].SABSADI; //就读年级
								this.ruleForm.hadSABI = response.data.KKDT[0].HADSABI; //就读班级
	
								this.habChangeData = response.data.KKDT[0];
								
								this.getSAD(this.ruleForm.valueSABSAAI); //获取年级信息
								this.getSAB(this.ruleForm.valueSABSADI); //获取班级信息	
							
							} 
							else {
								this.$message({
									message: '获取数据失败', //无数据
									type: 'error'
								});
							}
						} 
						else {
							this.$message({
								message: '请求获取数据失败', //请求失败
								type: 'error'
							});
						}
					})
					.catch((error) => {
						this.$message({
							message: '请求获取数据失败', //请求失败
							type: 'error'
						});
					});
			},
			//保存宝宝信息
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
	
						const self = this;
						

						var valDELF;
						if(self.ruleForm.habDELF == "undefined")
						{
							valDELF = '';
						}
						else
						{
							valDELF = self.ruleForm.habDELF;
						}
						let habFlag=false;
						if(this.habChangeData.HABNAME != this.ruleForm.habNAME)
						{
							habFlag = true;
						}
						
						if(this.habChangeData.HABPHOT != this.ruleForm.imgbase64)
						{
							habFlag = true;
						}
						
						if(this.habChangeData.HABBIRT != this.ruleForm.habBIRT)
						{
							habFlag = true;
						}
					
						if(this.habChangeData.HABDELF != valDELF)
						{
							habFlag = true;
						}
						
		
						var postUrl = 'WCF/WEB/svcHAB.svc/UPD_HAB_BYID';
						//网络请求接口
						this.$axios.post(
								//请求的url
								postUrl,
								//请求参数
								{
									sPHON: self.web_sphon,  //web侧 登录ID  tihs.web_suuid
									sMSID: self.habMSID, //宝宝ID
									sHABNAME: self.ruleForm.habNAME, //宝宝名
									sHABPHOT: self.ruleForm.imgbase64, //头像
									sHABGSEX: self.ruleForm.habGSEX, //性别
									sHABDELF: valDELF, //性别
									sHABBIRT: self.ruleForm.habBIRT,//生日
									sHADSAAI: self.ruleForm.valueSABSAAI,
									sHADSABI: self.ruleForm.hadSABI
								}
							)
							.then((response) => {
								//请求成功返回的数据
								let resStatus = response.status; //200 代表请求成功
								let resKKSTR = response.data.KKSTR;

								if (resStatus == "200") {
									if (resKKSTR == "N") {
										this.$message({
											message: '宝宝信息更新失败', //编辑失败
											type: 'error'
										});
									} else if (resKKSTR == "Y") {
										this.$message.success('宝宝信息更新成功'); // 编辑成功
										this.$router.push('/childList') // 跳转路由到用户列表页
										this.$bus.$emit('change') //子组件可以使用$emit触发父组件的自定义事件

										var indexs;
										for (let i = 0; i < this.COMM.tagsLists.length; i++) {
											if (this.COMM.tagsLists[i].name == "editChild") {
												indexs = i;
												break;
											}
										}
										this.closeTags(indexs);
									}
								} else {
									this.$message({
										message: '请求更新宝宝信息失败', //请求失败
										type: 'error'
									});
								}
							})
							.catch((error) => {
								this.$message({
									message: '请求更新宝宝信息失败', //请求失败
									type: 'error'
								});
							});
					} else {
						this.$message({
							message: '信息更新失败', //表单验证失败
							type: 'error'
						});
						return false;
					}
				});
			},
			// 幼儿园选择事件
			SABSAAIchange() {
				// debugger;
				//console.log(this.ruleForm.valueSABSAAI);
				if ( typeof(this.ruleForm.valueSABSAAI) !== 'undefined') {
					
					this.getSAD(this.ruleForm.valueSABSAAI);
					
					this.SABSADIdisabled = false;
				
					this.ruleForm.valueSABSADI='';
					
					this.ruleForm.hadSABI='';
					this.HADSABIdisabled = true;
					
				} else {
					this.SABSADIdisabled = true;
				}
			},
			// 年级选择事件
			SABSADIchange() {
				// debugger;
				//console.log(this.ruleForm.valueSABSADI);
				if ( typeof(this.ruleForm.valueSABSADI) !== 'undefined') {
					
					this.getSAB(this.ruleForm.valueSABSADI);
					
					this.HADSABIdisabled = false;
				
					this.ruleForm.hadSABI='';
					
				} else {
					this.HADSABIdisabled = true;
				}
			},
			// 关闭单个标签
			closeTags(index) {
				const delItem = this.COMM.tagsLists.splice(index, 1)[0];
				const item = this.COMM.tagsLists[index] ? this.COMM.tagsLists[index] : this.COMM.tagsLists[index - 1];
				if (item) {
					delItem.path === this.$route.fullPath && this.$router.push(item.path);
				} else {
					this.$router.push('/');
				}
			},
			//返回
			goBack() {
				this.$router.go(-1);

				var indexs;
				for (let i = 0; i < this.COMM.tagsLists.length; i++) {
					if (this.COMM.tagsLists[i].name == "editChild") {
						indexs = i;
						break;
					}
				}

				this.closeTags(indexs);
			}
		}
	}
</script>
<style scoped>
	.avatar-uploader >>> .el-upload--text {
		background-color: #fff;
		border: 1px solid #d9d9d9;
		border-radius: 128px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		width: 128px;
		height: 128px;
		text-align: center;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}
	.el-form-item__error {
		font-size: 14px;
		margin-top: 8px;
	}
	.el-dialog__footer {
		text-align: center;
		height: 80px;
	}

	.el-dialog__footer button {
		width: 94px;
		height: 36px;
		font-size: 14px;
	}
	.select-shop .el-input {
		width: 300px;
	}

	.submit {
		margin-left: 35%;
	}

	.submit button {
		width: 94px;
		height: 36px;
		font-size: 14px;
	}

	.goback {
		margin-right: 15px;
	}

	.el-row {
		margin-top: 16px;
	}

	.el-input {
		width: 90%;
	}

	.el-input--small .el-input__inner {
		height: 36px;
		line-height: 36px;
		font-size: 14px;
		padding-left: 10px;
	}

	.avatar-uploader .el-upload {
		width: 128px;
		height: 128px;
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 128px;
		height: 128px;
		line-height: 128px;
		text-align: center;
	}

	.avatar {
		width: 128px;
		height: 128px;
		display: block;
	}

	.cropper {
	    width: auto;
	    height: 300px;
	}
</style>
